export default function () {
    let howLong = $("#how_long");
    function updatePrices() {
        let selectedDuration = parseFloat(howLong.val());
        let pricePerHour = 250;

        $(".card").each(function () {
            let card = $(this);
            let initialPrice = parseFloat(card.find(".price").data("price"));
            let newPrice = (selectedDuration - 1) * pricePerHour + initialPrice;

            card.find(".price").text(newPrice.toFixed(2));

            if (card.find('#train_select').length > 0) {
                let trainCount = parseInt(card.find('#train_select').val());
                newPrice = newPrice * trainCount;
                card.find(".price").text(newPrice.toFixed(2));
            }
        });
    }

    $("#train_select").on("change", function () {
        updatePrices();
    });

    howLong.change(function () {
        updatePrices();
        $("#infoMessage").fadeIn().delay(2000).fadeOut(); // Show message and hide after 2 seconds
    });

    updatePrices();
}
